<template>
  <div class="product-edit">
    <VLoader v-show="isLoading" />

    <div v-show="!isLoading">
      <div>
        <div class="product-edit__header">
          <h2 class="text-bold">
            {{ getMessageByLang("createProduct", "Создание продукта") }}
          </h2>

          <div class="app-header-control">
            <Button @click="cancel">{{
              getMessageByLang("cancel", "Отмена")
            }}</Button>
            <Button @click="handleSave" :theme-color="'primary'">
              {{ getMessageByLang("btnSave", "Сохранить") }}
            </Button>
          </div>
        </div>

        <div class="product-edit__form">
          <div class="product-edit__form-create">
            <Form
              ref="productFormCreate"
              :ignoreModified="false"
              @submit="submitForm"
              :initialValues="product"
            >
              <ProductForm ref="RefProductForm" :isShowSubmit="false" :updatePriceType="updatePriceType" />
            </Form>
          </div>

          <div class="product-edit__photos">
            <ProductPhotos ref="RefPhotos" />
          </div>

          <div class="product-edit__options">
            <ProductOptions
              ref="RefProductOptions"
              :listOptions="product.options"
            />
          </div>
        </div>

        <div class="product-edit__footer">
          <Button @click="handleSave" :theme-color="'primary'">
            {{ getMessageByLang("btnSave", "Сохранить") }}
          </Button>
        </div>
      </div>
    </div>

    <AppNotification
      :text="textNotification"
      :close="handleCloseNotification"
      v-if="textNotification"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { getRespErrorMessage } from "@/utils/errors.js";
import { getMessageByLang } from "@/utils/translate.js";
import { getRole, getUrlWithRole } from "@/utils/router";

import Api from "@/api";

import { Form } from "@progress/kendo-vue-form";
import { Button } from "@progress/kendo-vue-buttons";

import VLoader from "@/ui-kit/components/VLoader.vue";
import ProductForm from "@/components/forms/ProductForm.vue";
import ProductOptions from "@/components/product/ProductOptions.vue";
import ProductPhotos from "@/components/product/ProductPhotos.vue";
import AppNotification from "@/components/AppNotification.vue";

const router = useRouter();

const isLoading = ref(false);
const product = ref({});
const RefProductForm = ref(null);
const RefProductOptions = ref(null);
const RefPhotos = ref(null);
const textNotification = ref(null);
const isModeFrom = ref(false)

const handleCloseNotification = () => {
  textNotification.value = false;
};

const updatePriceType = (val) => {
  isModeFrom.value = val;
}

const handleSave = () => {
  const formValue = RefProductForm.value.kendoForm.values;
  const optionsVal = RefProductOptions.value.getData();

  const productVal = {
    ...formValue,
    base_price: formValue.base_price
      ? Number(formValue.base_price.replace(/\s/g, ""))
      : null,
    category_id: RefProductForm.value.selectedItem,
    options: optionsVal,
    mode_from: isModeFrom.value
  };

  handleCreateSubmit(productVal);
};

const submitForm = () => {};

const cancel = () => {
  showList();
};

const showList = () => {
  const role = getRole();

  if (role === "supplier") {
    router.push("/supplier/products");
  } else if (role === "client") {
    router.push("/client/products");
  } else {
    router.push("/admin/products");
  }
};

const prepareOptions = (list) => {
  return list.map((item) => {
    if (item.type.value === "single") {
      item.type = "single";
    } else if (item.type.value === 'mode_from') {
      item.type = 'mode_from'
    } else {
      item.type = "multiple";
    }

    item.price = 0;
    item.visible = 1;
    item.items = item.items.map((subItem) => {
      return {
        ...subItem,
        visible: 1,
      };
    });

    return item;
  });
};

const handleCreateSubmit = async (data = null) => {
  try {
    isLoading.value = true;

    if (!data) {
      isLoading.value = false;
      return;
    }

    const optionsList = prepareOptions(data.options);
    data.options = JSON.parse(JSON.stringify(optionsList));
    delete data.images;
    data.visible = 1;

    const role = getUrlWithRole();
    const response = await Api.product.create(data, role);
    if (response.status !== 200) {
      alert(getMessageByLang('saveError', "Ошибка сохранения"));
      return;
    }

    let productId = data.id;
    if (!productId) {
      productId = response.data.data.id;
    }

    const images = RefPhotos.value.getPhotos();
    if (images && images[0]) {
      await Api.product.saveImg(productId, images);
    }

    showList();

  } catch (err) {
    console.error(err);

    const message = getRespErrorMessage(err);
    alert(message);
  } finally {
    isLoading.value = false;
  }
};
</script>

<style lang="scss">
.product-edit {
  &__header {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  &__photos {
    margin-top: 1rem;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>